(function () {
  'use strict';
  if (window.PSTCatalogueColours) return;
  var cache = new Map();
  var initialized = new WeakSet();
  function assetUrl(registryUrl, filename) {
    return new URL(filename, new URL(registryUrl, window.location.origin).href).href;
  }
  function registry(url) {
    if (!cache.has(url)) cache.set(url, fetch(url).then(function (r) {
      if (!r.ok) throw new Error('Colour preview could not load.');
      return r.json();
    }).catch(function (e) { cache.delete(url); throw e; }));
    return cache.get(url);
  }
  function selectColour(design, colours, id) {
    if (!design || !['MONOCHROME_MASK','FIXED_PLUS_ACCENT'].includes(design.preview_mode)) return null;
    if (!Array.isArray(design.development_color_ids) || design.development_color_ids.indexOf(id) < 0) return null;
    return colours.find(function (c) { return c.color_id === id && c.production_status !== 'DISABLED' && /^#[0-9a-f]{6}$/i.test(c.preview_hex); }) || null;
  }
  function colourUrl(productUrl, id) {
    var url = new URL(productUrl, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Invalid product link.');
    url.searchParams.set('colour', id);
    url.searchParams.delete('size');
    return url.pathname + url.search + url.hash;
  }
  async function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    var controls = root.querySelector('[data-pst-card-swatches]');
    var status = root.querySelector('[data-pst-card-status]');
    var canvas = root.querySelector('canvas');
    try {
      var values = await Promise.all([registry(root.dataset.paletteUrl), registry(root.dataset.designsUrl)]);
      var design = values[1].designs.find(function (d) { return d.design_id === root.dataset.designId; });
      if (!design || !['MONOCHROME_MASK','FIXED_PLUS_ACCENT'].includes(design.preview_mode)) return;
      var mask = design.accent_mask_asset || (design.size_web_mask_assets && design.size_web_mask_assets.L);
      if (!mask) return;
      var variantEntries = design.variant_colour_map ? Object.entries(design.variant_colour_map) : [];
      var purchasableIds = variantEntries.length ? variantEntries.map(function (entry) { return entry[1].color_id || entry[1]; }) : [design.default_color_id];
      var labelsById = Object.fromEntries(variantEntries.map(function (entry) {
        var value = entry[1];
        return [value.color_id || value, value.display_name || entry[0]];
      }));
      var colours = values[0].colors.filter(function (c) { return purchasableIds.indexOf(c.color_id) >= 0 && selectColour(design, values[0].colors, c.color_id); }).map(function (c) {
        return Object.assign({}, c, labelsById[c.color_id] ? { display_name: labelsById[c.color_id] } : {});
      });
      var highlights = ['BLACK_01','WHITE_01','GOLD_02','RACING_BLUE_01','RED_01'];
      colours.sort(function (a,b) {
        var ai=highlights.indexOf(a.color_id),bi=highlights.indexOf(b.color_id);
        return (ai<0?highlights.length:ai)-(bi<0?highlights.length:bi);
      });
      if (colours.length <= 1) return;
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      var current = null;
      var fixed = null;
      var imagePromise = null;
      function ensureImages() {
        if (imagePromise) return imagePromise;
        var layers = [new Promise(function(resolve,reject) {
          image.onload=resolve; image.onerror=reject;
          image.src=assetUrl(root.dataset.designsUrl,mask);
        })];
        if (design.fixed_art_asset) {
          fixed=new Image(); fixed.crossOrigin='anonymous';
          layers.push(new Promise(function(resolve,reject) {
            fixed.onload=resolve;fixed.onerror=reject;
            fixed.src=assetUrl(root.dataset.designsUrl,design.fixed_art_asset);
          }));
        }
        imagePromise=Promise.all(layers).catch(function(){imagePromise=null;throw new Error('Preview unavailable. Original artwork is shown.');});
        return imagePromise;
      }
      var media = root.closest('.ps-pcard').querySelector('.ps-pcard__media');
      if (media) media.appendChild(canvas);
      function draw() {
        if (!current || !image.complete || !image.naturalWidth || (fixed && !fixed.complete)) return;
        var width = Math.max(1, Math.round((media || canvas).clientWidth * Math.min(window.devicePixelRatio || 1, 2)));
        canvas.width = Math.min(width, 1440);
        canvas.height = Math.round(canvas.width * image.naturalHeight / image.naturalWidth);
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        ctx.globalCompositeOperation = 'source-in';
        ctx.fillStyle = current.preview_hex;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.globalCompositeOperation = 'source-over';
        if (fixed) ctx.drawImage(fixed,0,0,canvas.width,canvas.height);
      }
      var extraControls = root.querySelector('[data-pst-card-extra-swatches]');
      var moreControls = root.querySelector('[data-pst-card-more]');
      var buttonsByColour = new Map();
      async function showColour(colour, button, announce) {
        current = selectColour(design, values[0].colors, colour.color_id);
        if (!current) return;
        if (announce) status.textContent = 'Loading colour preview…';
        try { await ensureImages(); } catch(e) { canvas.hidden=true;status.textContent=e.message;return; }
        if (current.color_id !== colour.color_id) return;
        canvas.hidden = false;
        draw();
        root.querySelectorAll('.pst-card-colour').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
        status.textContent = colour.display_name + ' artwork preview · example bike shown' + (purchasableIds.indexOf(colour.color_id) >= 0 ? ' · available' : ' · preview only — not configured for checkout');
        if (!announce) return;
        var card = root.closest('.ps-pcard');
        if (card) {
          card.querySelectorAll('a').forEach(function (a) { a.href = colourUrl(a.href, colour.color_id); });
          var colourLabel = card.querySelector('.ps-pcard__colour');
          if (colourLabel) colourLabel.textContent = colour.display_name + ' preview';
        }
      }
      colours.forEach(function (colour, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'pst-card-colour';
        button.setAttribute('aria-label', colour.display_name);
        button.setAttribute('aria-pressed', 'false');
        button.title = colour.display_name;
        button.style.setProperty('--swatch', colour.preview_hex);
        buttonsByColour.set(colour.color_id, button);
        button.addEventListener('click', async function () {
          await showColour(colour, button, true);
        });
        if (index >= 5 && extraControls && moreControls) {
          extraControls.appendChild(button);
          moreControls.hidden = false;
        } else controls.appendChild(button);
      });
      root.hidden = false;
      var initialColour = colours.find(function (colour) { return colour.color_id === design.default_color_id; }) || colours[0];
      status.textContent = 'Loading design artwork…';
      await showColour(initialColour, buttonsByColour.get(initialColour.color_id), false);
      if ('ResizeObserver' in window) new ResizeObserver(draw).observe(media || root);
    } catch (e) {
      status.textContent = e.message;
    }
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-pst-card-colours]').forEach(function (root) {
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { observer.disconnect(); initialize(root); }
        }, { rootMargin: '200px' });
        observer.observe(root.parentElement);
      } else initialize(root);
    });
  }
  window.PSTCatalogueColours = { init: init, selectColour: selectColour, colourUrl: colourUrl, assetUrl: assetUrl };
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
